<template>
  <gh-business-tree :allow-drag="false" default-expand-all ref="tree" v-model="parent" module="dynamic_cls"
    cls="5cb053d8d2a0eb084830eb5f" :attached-all="true" @current-change="change">
    <template v-slot="{node,data}">
      <v-icon color="success">{{data.icon}}</v-icon>{{data.Name}}({{data.Demo}})
    </template>
  </gh-business-tree>
</template>

<style scoped>

</style>

<script>
  import LevelNavigation from "./levelNavigation.ts";
  export default LevelNavigation;
</script>